// Copyright (c) 2025 Audere, All Rights Reserved

import { Box, Typography } from "@mui/material";
import { createStyleSheet } from "../utils/styles";
import { theme } from "../../theme";
import type { InfoBannerProps } from "../types/projects";

const InfoBanner = (props: InfoBannerProps) => {
  const { icon, message, hasError } = props;
  const bgColor = hasError ? theme.palette.infoBanner.main : theme.palette.successBackground.main;

  const fontColor = hasError ? theme.palette.infoBanner.dark : theme.palette.text.primary;

  return (
    <Box sx={{ ...styles.container, backgroundColor: bgColor, color: fontColor }}>
      {icon}
      <Typography variant="body2" sx={{ ...styles.message }}>
        {message}
      </Typography>
    </Box>
  );
};

export default InfoBanner;

const styles = createStyleSheet({
  container: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1.5),
    borderRadius: "4px",
  },
  message: {
    fontWeight: 500,
    fontStyle: "italic",
  },
});
